<template>
  <div class="search-bar-container">
    <label class="search-bar-label">
      <span class="dedicated-search-icon">
        <i class="glyphicon glyphicon-search" />
      </span>

      <input
        id="algolia_search"
        v-model="searchText"
        type="text"
        name="search"
        :placeholder="placeholder"
        autocomplete="off"
        spellcheck="false"
        class="dedicated-search-form dedicated-search-bar"
        @keyup="onKeyup"
      />
    </label>

    <button
      v-if="searchText.length > 0"
      class="btn dedicated-search-btn"
    >
      <i
        :class="removeButtonCssClasses"
        @click="clearQuery"
      />
    </button>
  </div>
</template>

<script>
  export default {
    props: {
      placeholder: {
        type: String,
        required: true
      },
      query: {
        type: String,
        required: true
      },
      removeButtonCssClasses: {
        type: String,
        required: true
      }
    },
    data() {
      return {
        searchText: this.query
      }
    },
    methods: {
      onKeyup(event) {
        this.$emit('change', event.target.value);
      },
      clearQuery() {
        this.searchText = '';
        this.$emit('change', '');
      }
    }
  };
</script>
